import React from 'react';
import { useBranding } from '@/lib/BrandingContext';
import legacyLogo from '@/assets/sst-logo.jpg';
import modernLogo from '@/assets/branding/SST.png';

export default function BrandLogo({ compact = false, ...props }) {
  const { theme } = useBranding();
  if (compact && theme === "modern") return <span className="brand-wordmark" role="img" aria-label="Seiko Sports Technologies">SEIKO</span>;
  return <img {...props} src={theme === 'legacy' ? legacyLogo : modernLogo} alt="Seiko Sports Technologies" data-brand-logo="" />;
}
